/**
 * Cells for client-built CSV exports.
 *
 * A cell that starts with = + - @ (or a tab / carriage return) is read as a
 * formula when the file is opened in Excel, LibreOffice or Google Sheets.
 * Order comments and patient fields are typed by account users, and the
 * exports are opened by someone else (an administrator, a lab), so a stored
 * value like =HYPERLINK("https://…?"&B2) would run in the reader's
 * spreadsheet. The API does not neutralize these values, so the export does.
 */

const FORMULA_START = /^[=+\-@\t\r]/;
// Signed numbers and percentages ("-0.5", "+12%") are data, not formulas;
// prefixing them would turn numeric columns into text.
const PLAIN_NUMBER = /^[-+]?\d+(\.\d+)?%?$/;

// Prefix a single quote so the spreadsheet shows the text as typed.
export const neutralizeFormula = value => {
  if (typeof value !== 'string' || !FORMULA_START.test(value) || PLAIN_NUMBER.test(value)) {
    return value;
  }
  return `'${value}`;
};

// One RFC 4180 cell: formula-safe, quoted only when it has to be.
export const toCsvCell = value => {
  if (value === null || value === undefined) return '';
  const text = String(neutralizeFormula(value));
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

// For react-csv, which wraps every value in double quotes but does not
// double the quotes inside it: formula-safe, inner quotes doubled.
export const toReactCsvValue = value => {
  const safe = neutralizeFormula(value);
  return typeof safe === 'string' ? safe.replace(/"/g, '""') : safe;
};
